import {resolveRelations} from 'vuex-model-store-generator/src/helpers'
import {Documento} from '@api/tramite'
const state     = {}
let getters     = {
  resolve : ({ maxRelationsResolve, key, relations }, _, __, rootGetters) => (item, level = 1) => {
    item = Object.assign(Documento.getDefault(), item)
    item.titulo=`${rootGetters['tramite_tipo_documento/name'](item.docu_idtipodocumento)} ${ 
      ('000000' +item.docu_numero_doc).slice(-6)
    } ${ item.docu_origen == 1 ? '-' + item.docu_fecha_doc.substr(0, 4) : ''
    } ${item.docu_siglas_doc != null ? '-' + item.docu_siglas_doc : ''}`
    return resolveRelations(item, { maxRelationsResolve, key, relations }, rootGetters, level)
  },
  name : ({ items, key }, {resolve}) => (id) => {
    let item = items.find(d => d[key] === id)
    item = resolve(item)
    return item ? item.titulo : null
  },
}
const actions   = {}
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}